import Vue from 'vue'
import Vuex from 'vuex'

import LogIn from './modules/Auth/LogIn'
import Register from './modules/Auth/Register'
import OfferTest from './modules/Form/OfferTest'
import Snackbar from './modules/Message/Snackbar'
import AlertErr from './modules/Message/Alert'
import Forget from './modules/Auth/ForgetPassword'
import GetResponse from './modules/GetResponse'
import PostResponse from './modules/PostResponse'
import DeleteResponse from './modules/DeleteResponse'
import PatchResponse from './modules/PatchResponse'
import PutResponse from './modules/PutResponse'
import TrackEvents from "./modules/TrackEvents";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    LogIn,
    OfferTest,
    Register,
    Snackbar,
    AlertErr,
    Forget,
    GetResponse,
    PostResponse,
    PutResponse,
    DeleteResponse,
    PatchResponse,
    TrackEvents
  }
})
